import { getRecaptchaV2Key, getRecaptchaV3Key } from '../utils/grecaptcha';

export default {
  data() {
    return {
      recaptchaChallengeToken: '',
      recaptchaV3Success: false,
      promptV3Challenge: false,
    };
  },
  computed: {
    flagRecaptchaEnabled() {
      return this.$store.get('config@recaptchaEnabled') || false;
    },
    renderV3Challenge() {
      return this.flagRecaptchaEnabled && this.promptV3Challenge;
    },
  },
  methods: {
    getRecaptchaV2Key,
    getRecaptchaV3Key,
    /**
     * Validate recaptcha token server side
     * @param {String} action the recaptcha action
     * @returns {Promise<Boolean>}
     */
    async recaptchaV3Validate(action) {
      const token = await this.recaptchaTokenGet(action);
      const { success } = await this.$coa.recaptchaVerify(token, action);

      return Promise.resolve(success || false);
    },
    /**
     * Get a token from recaptcha
     * @param {String} action the recaptcha action
     * @returns {Promise<String>}
     */
    async recaptchaTokenGet(action) {
      // eslint-disable-next-line no-undef
      const token = await grecaptcha.execute(window.grecaptchaId, { action });
      return Promise.resolve(token || '');
    },
    /**
     * Invoke recaptcha challenge if server validation returns falsey success
     */
    recaptchaInvokeChallenge() {
      this.recaptchaChallengeToken = '';
      this.promptV3Challenge = true;
    },
  },
};
